import { createClient } from "@supabase/supabase-js";
import { config } from "./config";

/**
 * The browser Supabase client, used for signing in and the 6-digit code only.
 * The CRM never reads tables through Supabase: all data comes from the API,
 * which checks the caller is staff on every request.
 */
export const supabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false, storageKey: "ff-admin-auth" },
});
